import { createSlice } from '@reduxjs/toolkit';

const initialState = { user: null };

const profesorSlice = createSlice({
	name: 'profesor',
	initialState,
	reducers: {
		updateProfesor: (state, action) => {
			return { ...state, user: action.payload };
		}
	}
});

export const { updateProfesor } = profesorSlice.actions;
export default profesorSlice.reducer;
